import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import sandClock from "../../../assets/icons/sandClock.webp";
import Filters from "../../../components/Filters";
import FilterItem from "../../../components/FilterItem";
import SeasonTable from "../../../components/season/SeasonTable";
import TableStructure from "../../../components/TableScruture";
import {
  createBlockSDates,
  getSeasonByNumber,
} from "../../../services/seasons";
import { getSupplies } from "../../../services/medicines";
import LoadingPage from "../../../components/LoadingPage";
import CommonTitle from "../../../components/CommonTitle";

import { getBlockDates } from "../../../utils/timeFuncs";
import ModalStructure from "../../../components/ModalStructure";
import { MdAdd } from "react-icons/md";
import { IS_LOCAL_ENV } from "../../../App";
import Notification from "../../../components/ui-elements/Notification";

//==================data hardcodeada de filtros======================

const selectPropsList = [
  {
    options: [
      {
        text: "Intervalo 1",
        value: 1,
      },
      {
        text: "Intervalo 2",
        value: 2,
      },
      {
        text: "Intervalo 3",
        value: 3,
      },
    ],
    title: "Intervalo",
    value: null,
    setValue: null,
  },
  {
    options: [
      {
        text: `${new Date()}`,
        value: new Date(), //mongo usa IsoDate
      },
      {
        text: `${new Date()}`,
        value: new Date(),
      },
      {
        text: `${new Date()}`,
        value: new Date(),
      },
    ],
    title: "Fecha de registro",
    value: null,
    setValue: null,
  },
  {
    options: [
      {
        text: `${new Date()}`,
        value: new Date(), //mongo usa IsoDate
      },
      {
        text: `${new Date()}`,
        value: new Date(),
      },
      {
        text: `${new Date()}`,
        value: new Date(),
      },
    ],
    title: "Fecha fin",
    value: null,
    setValue: null,
  },
];

//===========data hardcodeada tabla==================

//===================================================

const Season = ({}) => {
  const [editingFD, setEditingFD] = useState(false);
  const [updating, setUpdating] = useState(false);
  const { seasonNumber } = useParams();
  const [loadFilter, setLoadFilter] = useState(false);
  const [loading, setLoading] = useState(true);
  const [interval, setInterval] = useState(null); //valor a setear en el select
  const [regDate, setRegDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [supplies, setSupplies] = useState([]);
  const [seasonInfo, setSeasonInfo] = useState({});
  const [validData, setValidData] = useState(false);
  const [newDate, setNewDate] = useState("");
  const [showModal, setShowModal] = useState(false);

  const navigate = useNavigate();

  //======================Fetch data=========================
  useEffect(() => {
    const fetchSeasonAndSupplies = async () => {
      try {
        const response = await getSeasonByNumber(seasonNumber, 2);
        const response2 = await getSupplies();
        if (response2.totalDocs == 0) {
          Notification({
            title: "Error",
            text: `Aún no hay medicinas registradas`,
            type: "Error",
          });
          navigate("/home/temporadas");
        }
        setSupplies(response2.docs);
        setSeasonInfo(response[0]);
        IS_LOCAL_ENV && console.log(response[0]);
      } catch (err) {
        IS_LOCAL_ENV && console.error(err);
      }
    };
    fetchSeasonAndSupplies();
  }, []);

  //=========================================================

  useEffect(() => {
    if (seasonInfo.blocks && supplies.length > 0) {
      IS_LOCAL_ENV && console.log(seasonInfo);
      setLoading(false);
    }
  }, [seasonInfo, supplies]);

  //setters
  const changeInterval = (e) => {
    setInterval(e.target.value);
  };
  const changeRegDate = (e) => {
    setRegDate(e.target.value);
  };
  const changeEndDate = (e) => {
    setEndDate(e.target.value);
  };

  useEffect(() => {
    selectPropsList[0].value = interval;
    selectPropsList[0].setValue = changeInterval;

    selectPropsList[1].value = regDate;
    selectPropsList[1].setValue = changeRegDate;

    selectPropsList[2].value = endDate;
    selectPropsList[2].setValue = changeEndDate;

    setLoadFilter(true);
  }, [interval, regDate, endDate]);
  //completar atributos en selectPropsList

  //=========pagination props====================
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = 1;

  //=============================================

  const changeSeasonValue = (blockPos, prop, newValue) => {
    let temp = { ...seasonInfo };
    temp.blocks[blockPos][prop] = newValue;
    setSeasonInfo(temp);
  };

  //=================================================
  const validBlocks = (season) => {
    let valid = true;
    for (const block of season.blocks) {
      if (block.supplies?.length == 0 || !block.supplies) {
        valid = false;
        break;
      }
    }
    return valid;
  };

  const onClickSaveSeason = () => {
    setUpdating(true);
    if (!validBlocks(seasonInfo)) {
      Notification({
        title: "Error",
        text: `Verifica la lista de medicina de los bloques, o las fechas de inicio y fin`,
        type: "Error",
      });

      setUpdating(false);
      return;
    } else {
      const handleSaveSeason = async () => {
        //guardar temporada y crear fechas programadas
        //asumiendo que los cambios de props de bloque ya se actualizaron,
        //solo habria que crear la temporada y redirigir al panel de riego
        //cambiar estado de temporada a pendiente
        try {
          const dates = seasonInfo.blocks.map((block) => {
            //array de objetos
            IS_LOCAL_ENV && console.log(block);
            const blockDates = getBlockDates(
              block.initDate,
              block.endDate,
              parseInt(block.interval)
            );

            return { blockInfo: block, datesToCreate: blockDates };
          });
          IS_LOCAL_ENV && console.log("fechas: ", dates);
          const response = await createBlockSDates(dates);
          IS_LOCAL_ENV && console.log(response);
          setUpdating(false);
          Notification({
            title: "Operación completada",
            text: `Se crearon las fechas programadas`,
            type: "Success",
          });
          navigate(`/home/temporadas/${seasonInfo.number}/programa`);
        } catch (err) {
          setUpdating(false);
          Notification({
            title: "Error",
            text: `Algo salió mal...`,
            type: "Error",
          });
          //cambiar luego a solo mostrar en development
          console.error(err);
          console.log(err);
        }
      };
      handleSaveSeason();
    }
  };

  return (
    <div className="w-full flex h-full flex-col items-center justify-center">
      {loading ? (
        <LoadingPage />
      ) : (
        <>
          <CommonTitle
            img={sandClock}
            title={`Temporada ${seasonNumber}`}
            text={"Modifica los intervalos y fechas de bloques"}
          >
            <div className="flex flex-col gap-y-2 items-center">
              <div className="font-poppins text-default-gray ">
                Inicia:{" "}
                {`${new Date(seasonInfo.initDate).toLocaleDateString("es-ES", {
                  day: "numeric",
                  month: "long",
                  timeZone: "America/Lima",
                })}`}
              </div>
              <div className=" flex flex-row items-center bg-light-purple rounded-full font-poppins px-6 py-4 text-dark-purple font-bold">
                Finaliza:{" "}
                {`${new Date(seasonInfo.endDate).toLocaleDateString("es-PE", {
                  day: "numeric",
                  month: "long",
                  timeZone: "America/Lima",
                })}`}
              </div>
            </div>
          </CommonTitle>
          {/* <Filters>
            {loadFilter &&
              selectPropsList.map((props, i) => {
                return <FilterItem props={props} key={i} />;
              })}
          </Filters> */}
          <div className="flex flex-col w-full max-w-[1280px] font-poppins text-dark-green m-4 md:px-32 px-4 items-start">
            <p>
              La fecha de fin de cada bloque no puede ser mayor a la fecha fin
              de la temporada
            </p>
            <p>
              En caso necesites agregar algún bloque,{" "}
              <Link
                to={`bloques`}
                className={"text-blue-600 hover:text-blue-400"}
              >
                accede aquí
              </Link>
            </p>
            <p>
              <b>
                Recuerda actualizar los cambios de bloque que realices antes de
                guardar y crear la temporada.
              </b>
            </p>
          </div>
          <TableStructure
            customMaxWidth={"max-w-[1100px]"}
            paginationProps={{ currentPage, setCurrentPage, totalPages }}
          >
            <SeasonTable
              data={seasonInfo}
              supplies={supplies}
              updateVD={(b) => setValidData(b)}
              updateParentProps={changeSeasonValue}
            />
          </TableStructure>
          {showModal && (
            <ModalStructure
              handleCloseModal={() => setShowModal(false)}
              customMaxW={"max-w-[350px]"}
            >
              <div className="flex flex-col items-center justify-center gap-y-4 my-2 font-poppins">
                <h3 className="font-poppins font-bold text-dark-green text-wrap text-lg">
                  Crear programa
                </h3>
                <span className="text-default-gray w-full text-center px-4 text-wrap">
                  Estás por crear un programa para la temporada{" "}
                  <b>{seasonInfo.number}</b>. Esta acción es irreversible.
                </span>

                <button
                  className={` w-fit  text-lg  flex justify-center rounded-full py-2 px-4 text-white  ${
                    updating
                      ? "bg-default-gray cursor-not-allowed"
                      : "bg-light-purple-600 hover:bg-dark-purple"
                  }   transition-all duration-100 font-bold font-poppins `}
                  onClick={onClickSaveSeason}
                  disabled={updating}
                >
                  <span className="flex flex-row items-center gap-x-2">
                    <span>{updating ? "Creando..." : "Crear programa"}</span>
                  </span>
                </button>
              </div>
            </ModalStructure>
          )}
          {seasonInfo.status == "hidden" ? (
            <button
              className={` w-fit  text-xl mb-6 flex justify-center rounded-full py-4 px-8 text-white ${
                !validData || updating
                  ? "bg-default-gray cursor-not-allowed"
                  : "bg-light-purple-600 hover:bg-dark-purple"
              }  transition-all duration-100 font-bold font-poppins `}
              onClick={() => setShowModal(true)}
            >
              <span className="flex flex-row items-center gap-x-2">
                <span>Guardar temporada</span>
              </span>
            </button>
          ) : (
            <button
              className={` w-fit  text-xl mb-6 flex justify-center rounded-full py-4 px-8 text-white bg-light-purple-600 hover:bg-dark-purple transition-all duration-100 font-bold font-poppins `}
              onClick={() =>
                navigate(`/home/temporadas/${seasonInfo.number}/programa`)
              }
            >
              <span className="flex flex-row items-center gap-x-2">
                <span>Ver programa de riego</span>
              </span>
            </button>
          )}
        </>
      )}
    </div>
  );
};

export default Season;
